import crypto from "crypto"
import jwt from "jsonwebtoken"

import { SECRET_KEY } from "../constants.js"
import executeQuery from "../lib/db.js"
import log from "../log.js"

interface UserLogin {
	email: string
	password: string
	appID: number
}

// interface iPermission {
// 	permission: string
// }

const getUser = async ({ email, password, appID }: UserLogin) => {
	log(`Attempting to get user with email: ${email} and password: ${password}`)

	const encryptedPassword = crypto.createHash("sha256").update(password).digest("hex")

	let user
	// let permissions

	try {
		const userQuery = `
			select
				user_id,
				email_address,
				display_name
			from
				users
			join
				user_apps using (user_id)
			where
				email_address='${email}'
				and password='${encryptedPassword}'
				and app_id=${appID}
		`

		user = await executeQuery({ query: userQuery })
	} catch (err) {
		throw new Error(`Error executing userQuery: ${err instanceof Error ? err.message : String(err)}`)
	}

	// try {
	// 	const permissionsQuery = `select user_id, email_address, display_name from users where email_address='${email}' and password='${encryptedPassword}'`

	// 	permissions = await executeQuery({ query: permissionsQuery })
	// } catch (err) {
	// 	throw new Error(`Error executing permissionQuery: ${err.message}`)
	// }

	log(`encrypted password: ${encryptedPassword}`)
	log(`user: ${JSON.stringify(user)}`)

	if (user.length === 0) {
		// no user found
		return null
	} else {
		const { user_id } = user[0]
		// const { user_id, email_address, display_name } = user[0]
		const token = jwt.sign({ user_id, app_id: appID }, SECRET_KEY)

		// get list of apps
		// const user_apps = await executeQuery({
		// 	query:
		// 		"select app_name, dev_url, prod_url from apps where app_id in (select app_id from user_apps where user_id=" +
		// 		user_id +
		// 		")",
		// })

		// now add the relevant permissions in each of the apps
		// for (const app of user_apps) {
		// const app_permissions = await executeQuery({
		// 	query: `
		// 			select
		// 				permission
		// 			from
		// 				app_permissions
		// 			where
		// 				app_id=${appID}
		// 				and permission_id in (
		// 					select
		// 						permission_id
		// 					from
		// 						user_permissions
		// 					where
		// 						user_id=${user_id}
		// 				)
		// 				and app_id in (
		// 					select
		// 						app_id
		// 					from
		// 						user_apps
		// 					where
		// 						user_id=${user_id}
		// 				)
		// 		`,
		// })
		// app.permissions = app_permissions.map(({ permission }: { permission: iPermission }) => permission).join(",")
		// }

		return {
			// userID: user_id,
			// email: email_address,
			// displayName: display_name,
			// apps: user_apps,
			// permissions: app_permissions.map(({ permission }: { permission: iPermission }) => permission),
			token,
		}
	}
}

export default getUser
